define('all/hash-helper',[], function() {
    'use strict';

	var emptyOnPopState = function () {};

	var closePanelFunction = emptyOnPopState;

    return {
         setHashStateFunction: function(locate) {
             closePanelFunction = locate;
         },
		executeClosePanelFunction: function(){
			closePanelFunction();
			closePanelFunction = emptyOnPopState();
		}
    };
});

